import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'

import availableLanguages from './available-languages.reducer'

export default function createReducer(history, sharedReducers = {}) {
  return combineReducers({
    ...(sharedReducers || {}),
    router: connectRouter(history),
    availableLanguages,
  })
}
